import { FailedPayment } from '../FailedPayment/FailedPayment';
import { LoadingPayment } from '../LoadingPayment/LoadingPayment';
import { useProcessingPaymentLogic } from './useProcessingPaymentLogic';

export const ProcessingPayment = ({ hasFailed, farmSeasonId }: { hasFailed: boolean; farmSeasonId?: number }) => {
    useProcessingPaymentLogic({ farmSeasonId: farmSeasonId });
    return <>{hasFailed ? <FailedPayment /> : <LoadingPayment />}</>;
};
